import { FC, useState } from "react";
import {
  Avatar,
  Button,
  Grid,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { ThemeToggle } from "../../components";
import { useDispatch } from "react-redux";
import { logout } from "../../features/auth/AuthSlice";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import LogoutIcon from "@mui/icons-material/Logout";
import useUser from "../../hooks/useUser";
import { useNavigate } from "react-router";
import CustomerTitle from "./CustomerTitle";

interface Props {
  setRight: any;
  rightSidebar: boolean;
  setLeft: any;
  leftSidebar: boolean;
}

export const Header: FC<Props> = ({
  setRight,
  rightSidebar,
  setLeft,
  leftSidebar,
}) => {
  const { user } = useUser();
  const [t, i18next] = useTranslation();
  const dispatch = useDispatch();
  const [, setClicked] = useState<boolean>(true);
  const history = useNavigate();
  let date = new Date();

  const [currentDate] = useState<any>({
    day: date.getDate(),
    month: date.getMonth() + 1,
    year: date.getFullYear(),
  });

  const [, setAnchorElNot] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const openUser = Boolean(anchorElUser);

  const handleUserClick = (event: any) => {
    setAnchorElUser(event.currentTarget);
  };
  const handleClose = (code: any) => {
    setAnchorElNot(null);
    setAnchorElUser(null);
  };

  const logoutHandler = () => {
    dispatch(logout());
    setAnchorElUser(null);
    setClicked(false);
  };

  function stringToColor(string: string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  }

  function stringAvatar(name: string) {
    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`,
    };
  }

  return (
    <header className="header" role="banner">
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        style={{ minHeight: "100%" }}
      >
        <Grid item>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            style={{ minHeight: "100%" }}
          >
            <Grid item>
              <a
                className="header-btn btn press-scale-down"
                onClick={() => {
                  //setRight(false);
                  setLeft(!leftSidebar);
                }}
              >
                <span></span>
              </a>
            </Grid>
            {window.innerWidth > 992 && (
              <Grid item>{user ? <CustomerTitle /> : null}</Grid>
            )}
          </Grid>
        </Grid>

        <Grid item>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            style={{ minHeight: "100%" }}
          >
            {window.innerWidth > 992 && (
              <Grid item>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  style={{ minHeight: "100%" }}
                >
                  <div className="icon" style={{ marginRight: "15px" }}>
                    <i className="icon-calendar" />
                  </div>
                  <div className="date">
                    {currentDate.day}/{currentDate.month}/{currentDate.year}
                  </div>
                </Grid>
              </Grid>
            )}

            <Grid item>
              <ThemeToggle />
            </Grid>
            {!rightSidebar && (
              <Grid item>
                <div
                  className="header-sidebar-open"
                  /* style={{
                    backgroundImage: `url(${bg})`,
                  }} */
                >
                  <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Grid item>
                      <Button
                        id="menu-right"
                        aria-controls="menu-right"
                        aria-haspopup="true"
                        aria-expanded={openUser ? "true" : undefined}
                        onClick={handleUserClick}
                        className="menu-right"
                      >
                        <div className="icon">
                          <i className="icon-user" />
                        </div>
                      </Button>
                      <Menu
                        id="demo-positioned-menu"
                        aria-labelledby="demo-positioned-button"
                        anchorEl={anchorElUser}
                        open={openUser}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        sx={{ padding: 0 }}
                      >
                        <Card
                          sx={{ maxWidth: 345, backgroundColor: "#cccccc59" }}
                        >
                          <CardHeader
                            avatar={
                              <Avatar
                                alt={user?.given_name + " " + user?.family_name}
                                {...stringAvatar(
                                  user?.given_name + " " + user?.family_name
                                )}
                              />
                            }
                            title={user?.given_name + " " + user?.family_name}
                            //subheader={<CustomerTitle  />}
                          />
                        </Card>

                        <MenuItem onClick={() => history("/change-password")}>
                          <ListItemIcon>
                            <VpnKeyIcon fontSize="small" />
                          </ListItemIcon>
                          <ListItemText>
                            {t("actions.changePassword")}
                          </ListItemText>
                        </MenuItem>

                        <MenuItem onClick={() => logoutHandler()}>
                          <ListItemIcon>
                            <LogoutIcon fontSize="small" />
                          </ListItemIcon>
                          <ListItemText>{t("actions.logout")}</ListItemText>
                        </MenuItem>
                      </Menu>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </header>
  );
};

export default Header;
